import HundredBricksAPIError from '../../../../HundredBricksAPIError';
class AnnualSummaryError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AnnualSummaryError', ...args);
    }
}
export default AnnualSummaryError;
